import React, { Component } from "react";
import axios from "../../../custom-axios";
import { SpreedlyPayment, PetBestContentModal } from "../../../UI-Component-Library";
import { AppUtils } from '../../../utils/app-utils';
import { PaymentUtils } from "../../pages/user-profile/payment-settings/payment-utils";
import { ApiConstants } from "../../../utils/api-constants";
import { LoadMask } from '../../../utils/loadmask.util';

class SpreedlyPaymentComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: undefined,
      cardHolderName: '',
      cardExpiry: '',
      cardHolderNameError: '',
      cardExpiryError: '',
      cardNumberError: '',
      cvvError: '',
      errorMessage: '',
      agreementCheckbox: false,
      existingCheckbox: false,
      showAgreementModal: false,
      showExistingModal: false,
      applicationAgreementHtml: undefined,
      preExisitingConditionHtml: undefined,
    };
  }

  getSpreedlyKey() {
    axios
    .processGet(
      `${ApiConstants.URL_GET_ENV_KEY}`
    )
    .then((response) => {
      this.setState({
        key: response
      }, () => {
        this.initializeSpreedly()
      })
    })
  }

  submitPayment(token) {
    const payload = {
      spreedlyToken: token,
      insuranceQuoteId: this.props.quoteData.quoteId
    }
    let errorMessage = '';
    LoadMask.showPreloader(this.refs.cRef);
    axios
    .processPost(
      `${ApiConstants.URL_POST_SUBMIT_PAYMENT}/${this.props.formValues.microChipNumber}`,
      null,
      payload
    )
    .then((response) => {
      if (response.hasError) {
        errorMessage = 'Your payment couldn’t be processed. Please try again or use a different method.'
      } else {
        this.props.goBack(true);
      }
    })
    .finally(() => {
      LoadMask.hidePreloader(this.refs.cRef);
      this.setState({
        errorMessage
      });
    })
  }

  getAgreementHtml() {
    axios
      .processGet(
        `${ApiConstants.URL_GET_AGREEMENT_TEXT}/${this.props.quoteData.quoteId}`
      )
      .then((response) => {
        this.setState({
          applicationAgreementHtml: response
      })
    })
  }

  getExisitingConditionHtml() {
    axios
    .processGet(
      `${ApiConstants.URL_GET_EXISTING_CONDITION_TEXT}/${this.props.quoteData.quoteId}`
    )
    .then((response) => {
      this.setState({
        preExisitingConditionHtml: response
      })
    })
  }

  componentDidMount() {
    this.getAgreementHtml();
    this.getExisitingConditionHtml();
    this.getSpreedlyKey();
  }

  initializeSpreedly = () => {
    const that = this;
    window.Spreedly.init(this.state.key, {
      numberEl: "spreedly-number",
      cvvEl: "spreedly-cvv",
    });

    window.Spreedly.on("ready", () => {
      Spreedly.setPlaceholder('number', 'XXXX XXXX XXXX XXXX');
      Spreedly.setPlaceholder('cvv', 'CVV (e.g. 123)');
      Spreedly.setStyle("number", "width: 100%; font-size: 16px");
      Spreedly.setStyle("cvv", "width: 100%; font-size: 16px");
    });

    window.Spreedly.on("errors", (errors) => {
      this.setState({
        errorMessage: errors[0]?.message
      });
    });

    window.Spreedly.on('validation', function (inputProperties) {
      let numberParent = document.getElementById("spreedly-number");
      let cvvParent = document.getElementById("spreedly-cvv");
      let cardNumberError = '', cvvError = '';
      let cardHolderNameError = '', cardExpiryError = '';
      let emptyFieldCount = 0;
      numberParent.className = '';
      cvvParent.className = '';

      if (!inputProperties["validNumber"]) {
        numberParent.className = "ui-spreedly-payment-card__div-error";
        cardNumberError = 'Please enter a valid card number.'
        emptyFieldCount++;
      }

      if(!inputProperties["validCvv"]) {
        cvvParent.className = "ui-spreedly-payment-card__div-error";
        cvvError = 'Please enter a valid security code/CVV.'
        emptyFieldCount++;
      }

      if (AppUtils.isEmptyString(that.state.cardHolderName)) {
        cardHolderNameError = 'Please enter a valid cardholder name.'
        emptyFieldCount++;
      }

      if (!AppUtils.isValidExpiry(that.state.cardExpiry)) {
        cardExpiryError = 'Please enter a valid expiration date.'
        emptyFieldCount++;
      }

      that.setState({
        cardNumberError,
        cvvError,
        cardHolderNameError,
        cardExpiryError,
        errorMessage: emptyFieldCount === 4 ? 'Please fill out all required fields.' : ''
      }, () => {
        that.tokenizeCreditCard();
      })
    });

    window.Spreedly.on("paymentMethod", (token, data) => {
      this.submitPayment(token)
    });

    window.Spreedly.on('fieldEvent', function(name, type, activeEl, inputProperties) {
      if(name == "number") {
        let numberParent = document.getElementById("spreedly-number");

        if (type === "focus") {
          numberParent.className = AppUtils.isEmptyString(that.state.cardNumberError)
            ? "ui-spreedly-payment-card__div-focus"
            : "ui-spreedly-payment-card__div-error"
        }
        if (type === 'blur') {
          numberParent.className = AppUtils.isEmptyString(that.state.cardNumberError)
            ? ""
            : "ui-spreedly-payment-card__div-error"
         }

      }

      if(name == "cvv") {
        let cvvParent = document.getElementById("spreedly-cvv");

        if (type == "focus") {
          cvvParent.className = AppUtils.isEmptyString(that.state.cvvError)
            ? "ui-spreedly-payment-card__div-focus"
            : "ui-spreedly-payment-card__div-error"
        }
        if (type == "blur") {
          cvvParent.className = AppUtils.isEmptyString(that.state.cvvError)
            ? ""
            : "ui-spreedly-payment-card__div-error"
        }
      }
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    window.Spreedly.validate();
  };

  tokenizeCreditCard = () => {
    if (
      AppUtils.isEmptyString(this.state.cardExpiryError) &&
      AppUtils.isEmptyString(this.state.cardHolderNameError) &&
      AppUtils.isEmptyString(this.state.cardNumberError) &&
      AppUtils.isEmptyString(this.state.cvvError)
    ) {
      let cardExpiryMonth, cardExpiryYear;
      if (this.state?.cardExpiry && this.state?.cardExpiry.length > 0) {
        const splitted = this.state.cardExpiry.split("/");
        if (splitted && splitted.length === 2) {
          let currYearStart = Math.floor(new Date().getFullYear() / 1000);
          cardExpiryMonth = splitted[0];
          cardExpiryYear = `${currYearStart * 1000 + parseInt(splitted[1], 10)}`;
        }
      }
      let options = {
        full_name: this.state.cardHolderName,
        month: cardExpiryMonth,
        year: cardExpiryYear
      }
      window.Spreedly.tokenizeCreditCard(options);
    } else {
      AppUtils.focusOnDiv('spreedly-form');
    }
  }

  getPercentValue(value) {
    value = value * 100;
    return `${value}%`;
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleCardExpiryChange(e) {
    const formatted = PaymentUtils.formatExpiryDate(
      this.state.cardExpiry,
      e.target.value
    );
    this.setState({
      [e.target.name]: formatted,
    });
  }

  render() {
    return (
      <>
        <div ref="cRef">
          <SpreedlyPayment
            petName={this.props.planInfo?.animal?.animalName}
            errorMessage={this.state.errorMessage}
            plan = {this.props.planInfo.plan}
            annual = {'Unlimited'}
            deductible = {AppUtils.getConvertedPrice(
              this.props.planInfo?.deductible
            )}
            reimbursement={this.getPercentValue(this.props.planInfo?.reimbursement)}
            monthlyPrice = {AppUtils.getConvertedPrice(
              this.props.planInfo?.monthlyPremium
            )}
            transactionFee = { AppUtils.getConvertedPrice(
              this.props.quoteData.amount - this.props.planInfo?.monthlyPremium
            )}
            total = {AppUtils.getConvertedPrice(
              this.props.quoteData.amount
            )}
            policyStartDate = {this.props.quoteData.policyStartDate}
            accidentWaiting = {this.props.quoteData.accidentWaitingDate}
            illnessWaiting = {this.props.quoteData.illnessWaitingDate}
            cruciateWaiting = {this.props.quoteData.cruciateWaitingDate}
            creditCardHolderNameInputFieldProps={{
              name: 'cardHolderName',
              maxLength: 30,
              placeholder: 'Enter the cardholder’s full name',
              error: !AppUtils.isEmptyString(this.state.cardHolderNameError),
              hint: this.state.cardHolderNameError,
              value: this.state.cardHolderName,
              onChange: this.handleInputChange,
            }}
            creditCardExpiryInputFieldProps={{
              name: 'cardExpiry',
              value: this.state.cardExpiry,
              placeholder: 'MM/YY',
              error: !AppUtils.isEmptyString(this.state.cardExpiryError),
              hint: this.state.cardExpiryError,
              onChange: (e) => {
                this.handleCardExpiryChange(e);
              },
            }}
            creditCardCVVError={this.state.cvvError}
            creditCardNumberError={this.state.cardNumberError}
            agreementCheckboxProps={{
              checked: this.state.agreementCheckbox,
              onChange: (e) => {
                this.setState({
                  agreementCheckbox: e.target.checked
                })
              },
            } }
            preExistingCheckboxProps={{
              checked: this.state.existingCheckbox,
              onChange: (e) => {
                this.setState({
                  existingCheckbox: e.target.checked
                })
              },
            }}
            agreementModalProps={{
              onClick: (e) => {
                e.preventDefault();
                this.setState({
                  showAgreementModal: true,
                })
              }
            }}
            preExistingModalProps={{
              onClick: (e) => {
                e.preventDefault();
                this.setState({
                  showExistingModal: true,
                })
              }
            }}
            goBackButtonProps={{
              onClick: () => {
                this.props.goBack();
              }
            }}
            payButtonProps={{
              disabled: !(this.state.agreementCheckbox && this.state.existingCheckbox),
            }}
            onFormSubmit={(e) => {
              this.handleSubmit(e);
            }}
          />
        </div>
        <PetBestContentModal
          open={this.state.showAgreementModal}
          onClose={() => {
            this.setState({
              showAgreementModal: false,
            });
          }}
          modalHeadline={"Application Agreement"}
          html={this.state.applicationAgreementHtml}
          cancelButtonProps={{
            onClick: () => {
              this.setState({
                showAgreementModal: false,
              });
            },
          }}
        />
        <PetBestContentModal
          open={this.state.showExistingModal}
          onClose={() => {
            this.setState({
              showExistingModal: false,
            });
          }}
          modalHeadline={"Pre-Existing Conditions"}
          html={this.state.preExisitingConditionHtml}
          cancelButtonProps={{
            onClick: () => {
              this.setState({
                showExistingModal: false,
              });
            },
          }}
        />
      </>
    );
  }
}

export default SpreedlyPaymentComponent;